import {
  Component,
  OnDestroy,
  OnInit,
  ChangeDetectorRef,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Observable, Subscription } from "rxjs";
import * as Sentry from '@sentry/angular';
import { map, startWith } from "rxjs/operators";
import { MediaMatcher } from "@angular/cdk/layout";
import { RouteFilterService } from "../../../../services/Route-Filter.service";
import { IRouteMapRequest } from "../../../../models/IRouteMapRequest";
import { ToastrService } from "ngx-toastr";
import { MAT_DATE_FORMATS } from "@angular/material/core";
import { EstatusJSON } from "../../../../../../../shared/models/EstatusJSON";
import { MatDatepickerInputEvent } from "@angular/material/datepicker";
import { ResumeRouteMapDTO } from "../../../../models/ResumeRouteMapDTO";
import { StepDetailsRouteDTO } from "../../../../models/StepDetailsRouteDTO";
import { GroupStepRouteDTO } from "../../../../models/GroupStepRouteDTO";
import { RouteMapService } from "../../../../services/RouteMap.service";
import { MapHelperService } from "src/services/map-helper.service";
import { PanelResumeRouteService } from "../../../../services/Panel-Resume-Route.service";
import { SessionService } from "src/app/features/shared/services/Session.service";

import { environment } from "src/environments/environment";
import { LocationsService } from "src/app/features/map-features/sections/locations-section/services/Locations.service";

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: "DD/MM/YYYY",
  },

  display: {
    dateInput: "DD/MM/YYYY",
    monthYearLabel: "MMMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

interface IRequestMapRouteForm {
  identifier?: string;
  startDate: Date;
  endDate: Date;
}

@Component({
  selector: "route-filter",
  templateUrl: "./route-filter.component.html",
  styleUrls: ["./route-filter.component.css"],
  providers: [{ provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS }],
})
export class RouteFilterComponent implements OnInit, OnDestroy {
  myControl = new FormControl(<string>"");
  filteredOptions: Observable<string[]>;
  // itemsLocations: ILocationDTO[] = [];
  itemsList: string[] = [];
  $LocationsMin: Observable<EstatusJSON>;
  isSelectTime: boolean = false;
  isLoading: boolean = false;
  formValid: boolean = false;
  private requestUrl: any;
  checkedDia: boolean = true;
  maxStartDate: Date = new Date();
  minStartDate: Date = new Date();
  isDatePickerDisabled: boolean = false;
  showIdentifierError: boolean = false;
  isGettingLocations: boolean = false;
  placeholder = "Cargando opciones...";

  public request: IRequestMapRouteForm = {
    identifier: undefined,
    startDate: new Date(),
    endDate: new Date(),
  };
  isRawRequest: boolean = false;
  rawDate: Date = new Date();
  rawStartTime: string = "00:00";
  IsAuthenticated: boolean;
  requestToken: any;
  routeMapPoints: string[];
  public geojson_routeMap: string;
  directionsAPIJson: any;
  public $ItemsGet: string[] = [];
  public $Items: string[];
  public isMapix: boolean = false;
  customer: any;
  fullScreen: boolean = false;
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  _isVisiblePanel: boolean = true;

  subscription_checkAuthenticated: Subscription;
  subscription_getList: Subscription;
  subscription_getRouteMapGeoJson: Subscription;
  subscription_getDirectionsAPI: Subscription;
  subscription_routeFilterService: Subscription;
  subscription_vehiculo: Subscription;
  subscription_visibilityPanel: Subscription;
  isAdmin: boolean;
  $vehiculo: Observable<string> = new Observable<string>();

  constructor(
    private toastrService: ToastrService,
    private routeFilterService: RouteFilterService,
    private locationService: LocationsService,
    private panelResumeRouteService: PanelResumeRouteService,
    private mapHelper: MapHelperService,
    private sessionService: SessionService,
    private routeMapService: RouteMapService,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher
  ) {
    this.mobileQuery = media.matchMedia("(min-width: 769px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.isSelectTime = false;
    this.checkedDia = true;

    this.$vehiculo = this.routeFilterService.getVehiculo();
    this.subscription_vehiculo = this.$vehiculo.subscribe((element) => {
      this.request.identifier = element;
    });

    this.subscription_visibilityPanel = this.routeFilterService.getVisibilityPanel().subscribe((isVisible) => {
      this._isVisiblePanel = isVisible;
    });

  }

  ngOnInit(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
    this.getListLocationsService();
    this.request.startDate = new Date();
    this.request.endDate = new Date();
    this.rawDate = new Date();
    this.rawStartTime = "00:00";

    this.maxStartDate = new Date();
    this.maxStartDate.setDate(this.maxStartDate.getDate() + 1);
    this.minStartDate = new Date();
    this.minStartDate.setDate(this.minStartDate.getDate() - 15);

    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(""),
      map((value) => this._filter(value ?? ""))
    );
  }

  ngOnDestroy() {
    if (this.subscription_checkAuthenticated)
      this.subscription_checkAuthenticated.unsubscribe();
    if (this.subscription_getList) this.subscription_getList.unsubscribe();
    if (this.subscription_getRouteMapGeoJson)
      this.subscription_getRouteMapGeoJson.unsubscribe();
    if (this.subscription_getDirectionsAPI)
      this.subscription_getDirectionsAPI.unsubscribe();
    if (this.subscription_routeFilterService)
      this.subscription_routeFilterService.unsubscribe();
    if (this.subscription_vehiculo)
      this.subscription_vehiculo.unsubscribe();
    if (this.subscription_visibilityPanel)
      this.subscription_visibilityPanel.unsubscribe();
  }

  onClose(){
    this.routeFilterService.setVisibilityPanel(false);
  }

  checkURLSource() {
    this.sessionService.CheckURLSource();
    this.isMapix = this.sessionService.isMapix;
  }

  ngOnSelectTime() {
    if(!environment.production) console.log("change checkbox");
    // this.isSelectTime = !this.isSelectTime;
    // this.request.startTime = "00:00";
    // this.request.endTime = "24:00";
    // this.formValid = !this.formValid;
  }

  onSubmit() {
    if(!environment.production) console.log("fechas inicio", this.request.startDate.toISOString());
    if(!environment.production) console.log("fechas fin", this.request.endDate.toISOString());
    if(!environment.production) console.log("hora", this.rawStartTime);
    if(!environment.production) console.log("request identifier", this.request.identifier);

    if (!this.request.identifier) {
      this.showIdentifierError = true;
      return;
    }

    const isValidIdentifier = this.itemsList.some(
      (item) => item.toUpperCase() === this.request.identifier.trim().toUpperCase()
    );
    if (!isValidIdentifier) {
      this.showIdentifierError = true;
      this.toastrService.warning(
        "Identificador no válido",
        "Selecciona una opción de la lista antes de buscar"
      );
      return;
    }

    if (
      this.request.identifier &&
      this.request.startDate &&
      this.request.endDate
    ) {
      try {
        const startDate = new Date(this.request.startDate);
        const endDate = new Date(this.request.endDate);
        var startHour = "00:00";
        startDate.setHours(this.request.startDate.getHours() - 6);
        endDate.setHours(this.request.endDate.getHours() - 6);
        if (!this.isRawRequest)
          startHour = null;
        else
          startHour = this.rawStartTime;
        var requestRouteMap: IRouteMapRequest = {
          Identifier: this.request.identifier.trim(),
          StartDate: this.request.startDate.toISOString(),
          EndDate: this.request.endDate.toISOString(),
          StartHour: startHour,
        };

        if(!environment.production) console.log("updating...");

        this.getRouteMapService(requestRouteMap);
        this.showIdentifierError = false;
      } catch (error) {
        // this.request.startDate = null;
        if(!environment.production) console.log(error);
      }
    }
  }

  onClearForm() {
    this.request.startDate = new Date();
    this.request.endDate = new Date();
    this.rawDate = new Date();
    this.rawStartTime = "00:00";
    
    this.mapHelper.UpdateLayerGeoJson(
      "route-layer",
      this.mapHelper.Empty_GeoJson
    );
    this.mapHelper.UpdateLayerGeoJson(
      "points-layer",
      this.mapHelper.Empty_GeoJson
    );
    this.maxStartDate = new Date();
    this.maxStartDate.setDate(this.maxStartDate.getDate() + 1);
  }

  getListLocationsService() {
    this.isGettingLocations = true;
    this.subscription_getList = this.routeFilterService.GetRouteDataList()
      .subscribe({
        next: (data) => {
          if (data.isSuccess == true) {
            this.itemsList = data.result || [];
            this.isGettingLocations = false;
            this.placeholder = "Selecciona un identificador";
            if(!environment.production) console.log("getListLocationsService", this.itemsList);
          }else{
            this.isGettingLocations = false;
            this.placeholder = "No se encontraron identificadores";
            Sentry.captureMessage('RouteFilter.getListLocationsService: respuesta sin éxito', { level: 'warning', extra: { response: data } });
            console.error('Error al obtener lista de locaicones', data.message, data.result);
          }
        },
        error: (error) => {
          // TODO marca para complete despues
          this.isGettingLocations = false;
          this.placeholder = "No se encontraron identificadores";
          console.error('Error al obtener lista de locaciones', error);
        }
      });
  }
  displayFn(value: string): string {
    return value ?? "";
  }

  focusLocation() {
    if(this.itemsList.length > 0 && !this.isGettingLocations){
      this.getListLocationsService();
    }    
    const value = this.myControl.value;
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(value),
      map((option) => (option ? this._filter(option) : this.itemsList.slice()))
    );
  }

  private _filter(value: string): string[] {
    const filterValue = value.toUpperCase().toString();

    return this.itemsList.filter((option) =>
      option.toUpperCase().includes(filterValue)
    );
  }


  onOptionSelected(){
    this.isDatePickerDisabled = false;
    this.showIdentifierError = false;
  }

  getRouteMapService(routeMapRequest: IRouteMapRequest) {
    this.isLoading = true;

    this.subscription_routeFilterService = this.routeFilterService.getRouteData(routeMapRequest).subscribe({
      next: (resp) => {
        if(!environment.production) console.log(resp);
        this.isLoading = false;
        if (resp.isSuccess) {
          var resumeRoute = resp.result.resumeRouteMapDTO as ResumeRouteMapDTO;
          var detailsRoute = resp.result
            .detailsRouteDTO as StepDetailsRouteDTO[];
          var groupedRoute = resp.result
            .groupStepsRouteDTO as GroupStepRouteDTO[];
          if (resumeRoute != null) {
            if (resumeRoute.cantStops != "0" && resp.result.groupStepsRouteDTO != null) {
              this.routeMapService.showRouteMapLayers();
              this.updateComponentResume(
                resumeRoute,
                detailsRoute,
                groupedRoute,
                routeMapRequest
              );
              this.routeMapService.updateRouteMap(resumeRoute.sGeojsonResume);
            } else {
              this.toastrService.info(
                "Sin Resultados",
                "El identificador seleccionado no contiene información en ese rango de fechas"
              );
            }
          } else {
            this.toastrService.info(
              "Sin Resultados",
              "El identificador seleccionado no contiene información en ese rango de fechas"
            );
          }
        } else {
          if(resp.message == 'Bad Parameters'){
            this.toastrService.info("Error en la solicitud", "Verifica que el identificador exista");
          }else{
            this.toastrService.warning("Error en la solicitud", "No se pudo obtener la información de la ruta");
            console.error('Error al obtener datos de ruta', resp.message, resp.result);
            Sentry.captureMessage('RouteFilter.getRouteData: respuesta sin éxito', { level: 'warning', extra: { response: resp } });
          }
        }
      },
      error: (error) => {
        // TODO marca para complete despues
        console.error('Error al obtener datos de ruta', error);
        this.isLoading = false;
      }
    });
  }
  updateComponentResume(
    resumeRoute: ResumeRouteMapDTO,
    detailsRoute: StepDetailsRouteDTO[],
    groupedRoute: GroupStepRouteDTO[],
    request: IRouteMapRequest
  ) {
    this.panelResumeRouteService.setVisibilityPopup(true);
    
    this.panelResumeRouteService.setResume(resumeRoute);
    this.panelResumeRouteService.setDetails(detailsRoute);
    this.panelResumeRouteService.setGrouped(groupedRoute);
    if(!environment.production) console.log("groupedRoute", groupedRoute);
    this.mapHelper.SetBounds(JSON.parse(resumeRoute.sGeojsonResume));
    //this.panelResumeRouteService.setRequest(request);
  }

  limteFecha(event: MatDatepickerInputEvent<Date>) {
    if (event.value == null) {
      this.maxStartDate = null;
    } else {
      //si se llega a requerir que haya más de 15 días, usar este
      // const start = new Date(event.value).getTime();
      // const addedDays = 15 * 24 * 60 * 60 * 1000;
      // const end = new Date(start + addedDays);
      // this.maxEndDate = end;
      // this.minEndDate = new Date(event.value);
    }
  }

  onDateChange(event: any): void {
    this.request.startDate = this.rawDate;
    if(!environment.production) console.log("rawDate", this.rawDate, this.request.startDate);
    
  }

  setRawRequest() {
    this.isRawRequest = !this.isRawRequest;
  }
}
